import type { IconData } from '@stacksjs/iconify-core'

export const fahrenheitFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M7 5a2 2 0 1 0 0 4a2 2 0 0 0 0-4M1 7a6 6 0 1 1 12 0A6 6 0 0 1 1 7\" clip-rule=\"evenodd\"/><path fill=\"#8fbffa\" d=\"M22.284 4.5c-2.038 0-3.706.588-4.947 1.813C16.097 7.54 15.5 9.192 15.5 11.21v29.248c0 2.105.484 3.727 1.585 4.713l.01.008c1.089.922 2.887 1.321 5.256 1.321c.562 0 1.137-.013 1.716-.044c2.58-.14 4.258-2.425 4.258-4.89V31.61h11.324c1.365 0 2.496-.413 3.33-1.285c.897-.89 1.29-2.248 1.29-3.956c0-.694-.082-1.4-.246-2.088c-.468-1.969-2.44-2.886-4.263-2.886H28.19V14.85h13.688c1.368 0 2.501-.415 3.335-1.29c.89-.931 1.287-2.304 1.287-4.018c0-.687-.074-1.413-.228-2.126c-.428-1.984-2.39-2.915-4.215-2.915z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default fahrenheitFlat
